import { render, staticRenderFns } from "./Payroll-Setting.vue?vue&type=template&id=b3dc083c&scoped=true"
import script from "./Payroll-Setting.vue?vue&type=script&lang=js"
export * from "./Payroll-Setting.vue?vue&type=script&lang=js"
import style0 from "./Payroll-Setting.vue?vue&type=style&index=0&id=b3dc083c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dc083c",
  null
  
)

export default component.exports